import {getRequest} from "./api";

export const initSites = (store) => {
	if (store.state.sites.length> 0 ) {
		return;
	}
	getRequest("/data/real/getDianIfor").then(data=>{
		if(data){
			//let fmtRoutes=formatRoutes(data);
			//router.addRoutes(fmtRoutes);
			
			if(store.state.siteId==null){
				store.commit('initSiteId',data.data[0].id);
				store.commit('initSiteName',data.data[0].dianName);
			}
			
			
			store.commit('initSites',data.data)
		    //store.commit('initRoutes',fmtRoutes)									  
								  
		}
	})
}
export const timerSite=(store)=>{
			return setTimeout(()=>{
					 //debugger
			          getRequest('/data/real/getDianIfor').then(resp => {
			          	var json=resp.data;					
			          	if(json.length==0){
			          		this.$message({
			          		  type: 'info',//success/warning/info/error/;
			          		  message: "无符合条件的数据。"
			          		});
			          		//alert("无符合条件的数据。");								
			          	}else{
			          		
			          		//that.$data.sites=resp.data;
			          		store.commit('initSites',resp.data)
			          		//that.$store.state.sites=resp.data;
			          		//console.log(that.$store.state.sites);
							
							sessionStorage.setItem("timeId",timerSite(store));
			          	}
			          });
			        },60000)
}
